import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FaUsers, FaListUl, FaCar, FaPhone, FaEnvelope, FaUserTie, FaBuilding, FaUserShield, FaMapMarkerAlt, FaDollarSign, FaEnvelopeOpenText, FaCalendarCheck, FaTruck } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import { dashboardAPI } from '../api/apiClient';
import { useTranslation } from 'react-i18next';
import { FaBoxesStacked } from "react-icons/fa6";

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [counts, setCounts] = useState({
    Users: 0,
    Drivers: 0,
    Pending_Drivers: 0,
    Active_Drivers: 0,
    Drivers_Company: 0,
    Drivers_Vehicles: 0,
    Admins: 0,
    Postal_Areas: 0,
    Pricing_Distances: 0,
    Pricing_Groups: 0,
    Contact_Message: 0,
    Special_Bookings: 0,
    Bookings: 0,
    Regular_Bookings: 0,
    Fast_Bookings: 0,
    Transports: 0,
    Car_Transports: 0,
    Furniture_Transports: 0
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response = await dashboardAPI.counts();
        if (response.success) {
          setCounts(response.data.data);
        }
      } catch (err) {
        console.error('Failed to fetch dashboard counts:', err);
      }
    };
    fetchCounts();
  }, []);


  const handleCardClick = (label) => {
    switch (label) {
      case t("pending_drivers"):
        navigate("/admin/drivers/drivers-pending");
        break;
      case t("active_drivers"):
        navigate("/admin/drivers/drivers-approved");
        break;
      case t("drivers"):
        navigate("/admin/drivers");
        break;
      case t("users"):
        navigate("/admin/customers");
        break;
      case t("drivers_company"):
        navigate("/admin/drivers-company");
        break;
      case t("admins"):
        navigate("/admin/admin-company");
        break;
      case t("pricing_distances"):
        navigate("/admin/car-prices");
        break;
      case t("pricing_groups"):
        navigate("/admin/city-prices");
        break;
      case t("contact_message"):
        navigate("/admin/contact");
        break;
      case t("special-bookings"):
        navigate("/admin/special-bookings");
        break;
      case t("bookings"):
        navigate("/admin/bookings");
        break;
      case t("regular_bookings"):
        navigate("/admin/bookings", { state: { activeTab: "regular" } });
        break;
      case t("fast_bookings"):
        navigate("/admin/bookings", { state: { activeTab: "fast" } });
        break;
      case t("transports"):
        navigate("/admin/transports");
        break;
      case t("car_transports"):
        navigate("/admin/transports", { state: { activeTab: "car" } });
        break;
      case t("furniture_transports"):
        navigate("/admin/transports", { state: { activeTab: "furniture" } });
        break;
      default:
        break;
    }
  };

  const isClickableCard = (label) => {
    const clickableLabels = [t("pending_drivers"), t("active_drivers")];
    return clickableLabels.includes(label);
  };

  const data = [
    {
      icon: <FaUsers size={30} />,
      label: t("users"),
      value: counts.Users,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaUserTie size={30} />,
      label: t("drivers"),
      value: counts.Drivers,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaUserTie size={30} />,
      label: t("pending_drivers"),
      value: counts.Pending_Drivers,
      bg: "#ffc107",
      clickable: true
    },
    {
      icon: <FaUserTie size={30} />,
      label: t("active_drivers"),
      value: counts.Active_Drivers,
      bg: "#198754",
      clickable: true
    },
    {
      icon: <FaBuilding size={30} />,
      label: t("drivers_company"),
      value: counts.Drivers_Company,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaCar size={30} />,
      label: t("drivers_vehicles"),
      value: counts.Drivers_Vehicles,
      bg: "#0f1128"
    },
    {
      icon: <FaUserShield size={30} />,
      label: t("admins"),
      value: counts.Admins,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaMapMarkerAlt size={30} />,
      label: t("postal_areas"),
      value: counts.Postal_Areas,
      bg: "#0f1128"
    },
    {
      icon: <FaDollarSign size={30} />,
      label: t("pricing_distances"),
      value: counts.Pricing_Distances,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaDollarSign size={30} />,
      label: t("pricing_groups"),
      value: counts.Pricing_Groups,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaEnvelopeOpenText size={30} />,
      label: t("contact_message"),
      value: counts.Contact_Message,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("special-bookings"),
      value: counts.Special_Bookings,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("bookings"),
      value: counts.Bookings,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("regular_bookings"),
      value: counts.Regular_Bookings,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("fast_bookings"),
      value: counts.Fast_Bookings,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("transports"),
      value: counts.Transports,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("car_transports"),
      value: counts.Car_Transports,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaBoxesStacked size={30} />,
      label: t("furniture_transports"),
      value: counts.Furniture_Transports,
      bg: "#0f1128",
      clickable: true
    },
    {
      icon: <FaPhone size={30} />,
      label: t("total_sms"),
      value: counts.total_sms,
      bg: "#0f1128"
    },
    {
      icon: <FaEnvelope size={30} />,
      label: t("total_emails"),
      value: counts.total_emails,
      bg: "#0f1128"
    }
  ];

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-header">
        <h4 className="mb-0">{t('admin_area')}</h4>
      </div>
      <div className="py-4">
        <h3 className="mb-4 dashboard-title">{t('dashboard')}</h3>
        <Row>
          {data.map((item, idx) => {
            const isClickable = item.clickable || isClickableCard(item.label);
            return (
              <Col key={idx} xs={12} sm={6} md={6} lg={4} className="mb-4">
                <Card 
                  className={`dashboard-card shadow-sm h-100 ${isClickable ? 'clickable-card' : ''}`}
                  onClick={() => isClickable && handleCardClick(item.label)}
                  style={{ 
                    cursor: isClickable ? 'pointer' : 'default',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Card.Body className="d-flex align-items-center">
                    <div className="icon-container" style={{ backgroundColor: item.bg }}>
                      {item.icon}
                    </div>
                    <div>
                      <small className="text-muted text-uppercase dashboard-label">{item.label}</small>
                      <h4 className="mb-0 fw-bold">{item.value}</h4>
                    </div>
                    {isClickable && (
                      <div className="ms-auto">
                        <span className="text-muted">→</span>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
}